"use strict";
exports.__esModule = true;
exports.nodeDefExpressionFunctions = void 0;
var survey_1 = require("../../survey");
exports.nodeDefExpressionFunctions = [
    {
        name: 'parent',
        minArity: 1,
        maxArity: 1,
        evaluateToNode: true,
        executor: function (context) { return function (nodeDef) {
            var survey = context.survey;
            return survey_1.Surveys.getNodeDefParent({ survey: survey, nodeDef: nodeDef });
        }; }
    },
];
//# sourceMappingURL=functions.js.map